var x = Object.defineProperty;
var m = Object.getOwnPropertySymbols;
var c = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
var i = (r, e, o) => e in r ? x(r, e, { enumerable: !0, configurable: !0, writable: !0, value: o }) : r[e] = o, p = (r, e) => {
  for (var o in e || (e = {}))
    c.call(e, o) && i(r, o, e[o]);
  if (m)
    for (var o of m(e))
      n.call(e, o) && i(r, o, e[o]);
  return r;
};
var u = (r, e) => {
  var o = {};
  for (var a in r)
    c.call(r, a) && e.indexOf(a) < 0 && (o[a] = r[a]);
  if (r != null && m)
    for (var a of m(r))
      e.indexOf(a) < 0 && n.call(r, a) && (o[a] = r[a]);
  return o;
};
import { jsx as l, jsxs as h } from "react/jsx-runtime";
import { ModalHeader as v } from "./ModalHeader.js";
import { Breadcrumb as M } from "./Breadcrumb.js";
import { ModalFooter as N } from "./ModalFooter.js";
const q = (j) => {
  var s = j, {
    children: r,
    isIO: e = !1,
    closeModal: o,
    title: a,
    genericTaggingEvent: f,
    cancelButtonAction: d
  } = s, t = u(s, [
    "children",
    "isIO",
    "closeModal",
    "title",
    "genericTaggingEvent",
    "cancelButtonAction"
  ]);
  return /* @__PURE__ */ l("div", { className: "modal-rule-coupon-external", children: /* @__PURE__ */ h("div", { className: "modal-rule-coupon-internal", children: [
    /* @__PURE__ */ l(
      v,
      {
        closeModal: o,
        title: a,
        genericTaggingEvent: f
      }
    ),
    e && /* @__PURE__ */ l(M, { title: a, cancelButtonAction: d }),
    /* @__PURE__ */ l("div", { className: "modal-rule-coupon-children", children: r }),
    /* @__PURE__ */ l(
      N,
      p({
        cancelButtonAction: d
      }, t)
    )
  ] }) });
};
export {
  q as Modal
};
